import React, { useEffect, useRef, useState } from 'react';
import scrollIntoViewInfo, { ScrollIntoView } from '../schema/ScrollIntoView';
import { mergeStyles } from '@uifabric/merge-styles';
import { trace } from 'owa-trace';

const classNames = require('classnames');
const styles = require('./ScrollIntoViewHelper.scss');

interface ScrollIntoViewHelperProps {
    scrollIntoViewInfo: scrollIntoViewInfo;
}

/**
 * Component which renders the dummy time indicator for the scrollIntoView to take effect
 */
const ScrollIntoViewHelper: (props: ScrollIntoViewHelperProps) => JSX.Element = (
    props: ScrollIntoViewHelperProps
): JSX.Element => {
    const { scrollIntoViewInfo } = props;
    const { scrollIntoViewType, topPosition } = scrollIntoViewInfo;
    const timeIndicatorRef = useRef(null);
    const [isScrollIntoViewDone, setIsScrollIntoViewDone] = useState<boolean>(false); //State variable required to stop useEffect() being called recursively

    /**
     * Scrolls the scroll into view helper to the respective positions in the viewport
     */
    const scrollToPosition = () => {
        const scrollIntoViewOptions = scrollIntoViewType === ScrollIntoView.Bottom ? false : true;
        try {
            window.requestAnimationFrame(() => {
                timeIndicatorRef &&
                    timeIndicatorRef.current &&
                    timeIndicatorRef.current.scrollIntoView &&
                    timeIndicatorRef.current.scrollIntoView(scrollIntoViewOptions);
            });
        } catch (error) {
            trace.warn(`Error in scrolling to middle in day view current time indicator: ${error}`);
        }
    };

    useEffect(() => {
        if (!isScrollIntoViewDone) {
            scrollToPosition();
            setIsScrollIntoViewDone(true);
        }
    }, [scrollIntoViewInfo]);

    return (
        <div
            aria-hidden
            ref={timeIndicatorRef}
            className={classNames(styles.timeIndicator, mergeStyles({ top: topPosition }))}
        />
    );
};
export default ScrollIntoViewHelper;
